import _ from 'lib/underscore';
import 'public/js/jquery.autosize.min.js';
import {asNumber, asString} from "../../../core/utils/var";
import {siteUrl} from "../../../core/utils/url";
import {lang} from "../../../core/utils/lang";
import {newLogger} from "../../../core/utils/logger";
import loading from "../../../core/widgets/loading";
import {MODAL_LOGIN} from "../../../core/modals";
import {Notifier as notifier} from "../../../core/widgets/notifier";
import {openPopup} from "../../../core/widgets/popup";
import {Cart} from "../common/model/cart";
import {CartItem} from "../common/model/cartitem";
import {SaleItem} from "../common/model/saleitem"
import numeral from 'lib/numeral';

const logger = newLogger('CreateOrderForm');

export class CreateOrderForm {
	_onSuccess = $.Callbacks();
	_onLoad = $.Callbacks();

	_rawProduct = null;
	_currentSize = null;

	_xhr = null;

	isIndividual = ko.observable(false);

	isLoading = ko.observable(false);
	isLoaded = ko.observable(false);
	error = ko.observable();
	currentUrl = ko.observable(null);

	// fields
	orderName = ko.observable('');
	priceRaw = ko.observable('');
	stockRaw = ko.observable('').trimmed();
	additionalInfo = ko.observable('').trimmed();
	amount = ko.observable(1);
	checkingType = ko.observable('');
	selectedSaleId = ko.observable('');
	_shopInfo = null;

	// options
	orderNameReadOnly = ko.observable(false);
	priceReadOnly = ko.observable(false);
	stockRawRequired = ko.observable(false);
	isStockRawNoticeVisible = ko.observable(false);
	isVariantsVisible = ko.observable(false);
	isSizesVisible = ko.observable(false);
	isVariantSoldOut = ko.observable(false);
	isSizeSoldOut = ko.observable(false);
	isProductSoldOut = ko.observable(false);

	sales = ko.observableArray([]).indexBy('id');

	orderDisabled = ko.observable(false);
    orderDisabledMessage = ko.observable(null);
	submitDisabled = ko.observable(false);
	canAdd = ko.observable(true);
	maxPrice = ko.observable(0);

	constructor(selector, options) {
		this.$form = $(selector);

		if (this.$form.length !== 1 || !this.$form.is('form')) {
			logger.error('Invalid form selector');
			return;
		}

		this.o = {
			individual: false,

            checkingTypes: {},
            irParcelPrice: null,

			selectedSize: null,
			productName: null,
			productCost: null,

			orderId: null,
			orderData: null, // result of orderProduct call

			amount: 1,

			...options
		};

		this.amount(this.o.amount);

        this._cart = new Cart({
			checkingTypes: this.o.checkingTypes,
            irParcelPrice: this.o.irParcelPrice

        }, false);

		this.isIndividual(this.o.individual);

		this._prepare();

		this.price = ko.computed(() => {
			return asNumber((this.priceRaw() + '').replace(',', '.'));
		});
		this.price.subscribe(() => {
			this._updateComission();
		});
		this.amount.subscribe(() => {
			this._setPrice();
		});
		this.isCheckingAdviceVisible = ko.pureComputed(() => {
			return this.price() > 50 && !this.checkingType();
		});
		this._selectedSale = ko.pureComputed(() => {
		    return this.selectedSaleId() ? this.sales.get(this.selectedSaleId()) : null;
		});

		this.canContinue = ko.pureComputed(
			() => !this.submitDisabled()
				&& !this.orderDisabled()
				&& !(this.isSizeSoldOut() && this.isIndividual())
				&& this.canAdd()
		);

		if (this.o.orderId && this.o.orderData) {
			this.$form.find('input[name=order_id]').val(this.o.orderId);
			this._processResponse(this.o.orderData);
		}
	}

	/** @type {JQuery.Callbacks} */
	get onSuccess() {
		return this._onSuccess;
	}

	/** @type {JQuery.Callbacks} */
	get onLoad() {
		return this._onLoad;
	}

	/** @return {SaleItem} */
	get selectedSale() {
		return this._selectedSale();
	}

	_hiddenFields = {};

	/** @type {JQueryValidation.Validator} */
	_validator;

	_prepare() {
		prepareValidators();
		registerTemplates();

		this.$form.find('.product-image').fancybox({padding: 5, type: 'image'});
		this.$form.find('select[rel=chosen]').chosen();

		this._validator = this.$form.validate({
			ignore: '[type=hidden]',
			submitHandler: () => {
				if (this.isLoaded() && !this.submitDisabled()) {
					this._submit();
				}
			},
			// errorPlacement: () => {},
			highlight: (element, errorClass, validClass) => {
				// logger.log('highlight', element, errorClass, validClass);
				$(element).closest('.link-order-row')
					.removeClass('error valid')
					.addClass(errorClass).removeClass(validClass);
			},
			unhighlight: (element, errorClass, validClass) => {
				// logger.log('unhighlight', element, errorClass, validClass);
				$(element).closest('.link-order-row')
					.removeClass('error valid')
					.removeClass(errorClass).addClass(validClass);
			}
		});

		window.orderValidator = this._validator;

		// form.reset() does not affect hidden fields
		// so we should take care of them
		this.$form.find('input[type=hidden]').each((i, input) => {
			this._hiddenFields[$(input).attr('name')] = $(input).attr('value');
		});

		autosize(this.$form.find('textarea[name=additional_customer_raw]'));
	}

	_reset() {
		this.isLoaded(false);
		this.error('');
		this._setOrderName('');
		this._setPrice('');
		this.stockRaw('');
		this.additionalInfo('');
		this.amount(1);
		this.checkingType('');
		this.sales([]);
		this._validator.resetForm();
		this.currentUrl(null);
		$.each(this._hiddenFields, (key, val) => {
			this.$form.find('input[type=hidden][name=' + key + ']').val(val);
		});
		autosize.update(this.$form.find('textarea[name=additional_customer_raw]').val(''));
	}

	_showOrderSuccessMessage(serverResponse) {
		const data = {
			balance_link: siteUrl('balance'),
			status: 'on_hold',
			low_balance: false,
			debt: 0,
			debtpc: 0,
			debtpc_allowed: 1,
			currency_info: {
				rate: 1,
				sign: ''
			},
			...serverResponse
		};
		const ci = data.currency_info;
		const tmpl = data.low_balance ? 'co-popup-success-low-balance' : 'co-popup-success';
		const tmplData = {
			...data,
			debt_euro_f: numeral(data.debt).format('0.00') + ' &euro;',
			debt_converted_f: numeral(data.debt*ci.rate).format('0.00') + ' ' + ci.sign,
			currency_rate_f: numeral(ci.rate).format('0.00'),
			debtpc_f: numeral(data.debtpc).format('0%'),
			debtpc_allowed_f: numeral(data.debtpc_allowed).format('0%'),
			currency_sign: ci.sign,
		};
		openPopup($.tmpl(tmpl, tmplData), {
			cssClass: 'create-order-popup'
		});
	}

	_showCartSuccessMessage() {
        const tmplData = {};
        openPopup($.tmpl('cart-popup-success', tmplData), {
            cssClass: 'add-to-cart-success-popup'
        });
	}

	process(url) {
		this._reset();
		this.currentUrl(url);
		const $form = this.$form;

		if (this._xhr) {
			this._xhr.abort();
		}

		let link = $.trim(url);
		link = link.replace(/\s/g, '%20').replace('tablet.hm.com/', 'www.hm.com/').replace('m.hm.com/', 'www.hm.com/');
		if (!/^https?:\/\//i.test(link)) {
			return false;
		}

		const individual = this.isIndividual() ? 1 : 0;
		const shop_id = $form.find('input[name=shop_id]').val();
		let fromShop = $form.find('input[name=fromShop]');
		fromShop = (fromShop.length > 0) ? fromShop.val() : 0;
		$form.find('input[name=order_id]').val(link);

		this.isLoading(true);

		this._xhr = $.post(
			siteUrl('c_and_a/orderProduct'),
			{link: link, shop_id: shop_id, fromShop: fromShop, individual: individual},
			response => {
				if (response) {
					const result = this._processResponse(response);
					this._onLoad.fire(result);
				} else {
					this.error('Ошибка');
					this._onLoad.fire(false);
				}
			},
			'json'
		).always(() => {
			this.isLoading(false);
			this._xhr = null;
		}).fail((xhr, status) => {
			if (status != 'abort') {
				this.error('Ошибка');
				this._onLoad.fire(false);
			}
		});

		return true;
	}

	_processResponse(response) {
		const self = this;
		const $form = this.$form;
		const o = this.o;

		this.stockRawRequired(true);
		this.isStockRawNoticeVisible(false);
		this.isVariantsVisible(false);
		this.isSizesVisible(false);
		this.isVariantSoldOut(false);
		this.isSizeSoldOut(false);
		this.isProductSoldOut(false);
        this.orderDisabled(response.orderDisabled);
        this.orderDisabledMessage(response.orderDisabled ? response.orderDisabledMessage : null);
        // If chat message is set, open the chat
        if(response.orderDisabled && response.orderDisabledChatMessage !== undefined && window.jivo_api !== undefined) {
            jivo_api.showProactiveInvitation(response.orderDisabledChatMessage);
		}

		$form.find('.product-image,.wrap-variants-simple').hide();
		this._updateComission(0);
		this._rawProduct = null;
		const localImage = $form.find('input[name=productImage]').val();

		$form.find('.reviewsByProduct').html($.tmpl('co-reviews-by-product', response));
		$form.find('.reviewsByGroup').html($.tmpl('co-reviews-by-group', response));
		$form.find('.reviewsByShop').html($.tmpl('co-reviews-by-shop', response));

		$form.find('.wrap-rev-stats').toggle(response.count_by_shop != '0');

		$form.find('input[name=custom_sender_name]').val(response.shopName);
		$form.find('[name=comission]').val(response.comission);
		$form.find('[name=min_commission]').val(response.minCommission);

		if (response.name) {
			if (response.error) {
				this.error(response.error);
				return false;
			}

			this._setOrderName(response.name);

			if (response.stock && !_.isEmpty(response.stock)) {
				$form.find('.wrap-variants').html($.tmpl('co-variants', response));
				$form.find('input[name=variant]').change(function () {
					var $variantInput = $(this);
					const variantId = $variantInput.attr('variantId');
					const sizes = response.stock[variantId];
					$form.find('.wrap-sizes').html($.tmpl('co-sizes', {sizes: sizes}));
					$form.find('input[name=size]').change(function () {
						var $sizeInput = $(this);
						self._currentSize = $sizeInput.attr('id');
						self._setPrice();
						self._checkSubmitDisable();
						self.isSizeSoldOut($sizeInput.attr('soldout') == 1);
					});

					const $current = $form.find('#' + self._currentSize);
					if ($current.not(':disabled').length > 0) {
						$current.prop('checked', true).change();
					} else {
						$form.find('input[name=size]:first').prop('checked', true).change();
					}

					const image = $variantInput.attr('image');
					if (image) {
						self._showOrHideImageBlock('show');
						$form.find('.product-image img').attr('src', image).show();
						$form.find('.product-image').attr('href', $variantInput.attr('full_image')).show();
						$form.find("input[name=save_image]").val(image);
						$form.find("input[name=save_image_big]").val($variantInput.attr('full_image'));
					} else {
						self._showOrHideImageBlock('hide');
					}

					if (response.shopName == 'sportspar.de') {
						const selectedVariant = response.variants.find(v => v.id == variantId);
						self._setOrderName(selectedVariant.name);
					}

					self.isVariantSoldOut($variantInput.attr('soldout') == 1);

					self._setPrice();
					self._checkSubmitDisable();
				});
				$form.find('#variantRadio' + response.selected).prop('checked', true).change();
				self.isVariantsVisible(true);
//								setPrice();
				$form.find('[name=additional_customer_raw]')
					.attr({placeholder: zde.lang('txt_order_products_details_parsed_placeholder')})
					.height('170px');
				self.stockRawRequired(false);

				if (o.selectedSize) {
					$form.find('input[name=size][value="' + o.selectedSize + '"]').prop('checked', true).change();
				} else {
					const $sizes = $form.find('input[name=size]').not(':disabled');
					if ($sizes.length > 0) {
						const $sizeS = response.selectedSize ? $form.find('#sizeRadio' + response.selectedSize) : $($sizes[0]);
						$sizeS.prop('checked', true).change();
					}
					if (response.selected !== undefined && response.selected !== null) {
						$form.find('label[for*="variantRadio' + response.selected + '"]').click();
					} else {
						$form.find('label[for*="variantRadio"]:first').click();
					}
					if (response.selectedSize !== undefined && response.selectedSize !== null) {
						$form.find('label[for*="sizeRadio' + response.selectedSize + '"]').click();
					} else {
						$form.find('label[for*="sizeRadio0"]:first').click();
					}
				}

				self._setPrice();

                self.isSizesVisible(!response.isOneSize
					|| (response.stock[Object.keys(response.stock)[0]][0].sizeName !== 'no size'));
			} else {
				response.i = 0;
				$form.find('.wrap-variants-simple').html($.tmpl('co-variants-simple', response)).show();
				self._setPrice(response.price);
				if (o.selectedSize) {
					self.stockRaw('Размер: ' + o.selectedSize);
				} else {
					$form.find('[name=additional_customer_raw]').attr({placeholder: 'Введите сюда дополнительную информацию, если нужно...'});
				}

                self.isProductSoldOut(!!response.soldOut);

				if (response.image) {
					self._showOrHideImageBlock('show');
					$form.find('.product-image img').attr('src', response.image).show();
					$form.find('.product-image').attr('href', response.image).show();
					$form.find("input[name=save_image]").val(response.image);
					$form.find("input[name=save_image_big]").val(response.image);
				} else {
					self._showOrHideImageBlock('hide');
				}
			}

			self._rawProduct = response;
		} else {
			if (response.order_name) {
				this._setOrderName(response.order_name);
			} else {
				if (o.productName) {
					this._setOrderName(o.productName);
				}
				if (o.productCost) {
					self._setPrice(o.productCost);
				}
			}

			if (o.selectedSize) {
				self.stockRaw('Размер: ' + o.selectedSize);
			}

			$form.find('[name=additional_customer_raw]')
				.attr({placeholder: zde.lang('txt_order_products_details_not_parsed_placeholder')})
				.height('170px');

			if (localImage) {
				self._showOrHideImageBlock('show');
				$form.find('.product-image img').attr('src', localImage).show();
				$form.find('.product-image').attr('href', localImage).show();
				$form.find("input[name=save_image]").val(localImage);
				$form.find("input[name=save_image_big]").val(localImage);
			} else {
				self._showOrHideImageBlock('hide');
			}
			self._updateComission(0);
		}

		self.sales(_.map(response.sales, s => new SaleItem(s)));

		self._shopInfo = response.shopInfo !== undefined ? response.shopInfo : null;

		// do some actions after knockout has finished with DOM manipulation
		setTimeout(() => {
			$form.find('select[rel=chosen]').trigger('chosen:updated');
			this._validateFields();
		});

		this.isLoaded(true);

		if(this.isIndividual()) {
			this._cart.load();
            this.maxPrice(this._cart.maxPrice);
		} else {
            this.submitDisabled(false);
            if(window.fbq) fbq('track', 'InitiateCheckout');
		}

		return true;
	}

	/**
	 * Validate name and price fields if they are filled to make validator mark them as valid
	 * @private
	 */
	_validateFields() {
		if (this.orderName()) {
			this._validator.element(this.$form.find('[name=order_name]'));
		}
		if (this.price()) {
			this._validator.element(this.$form.find('[name=sum]'));
		}
	}

	_tempSubmit() {
		const isAvailableHnm = this._shopInfo && this._shopInfo.name === 'hm.com' && !this.isSizeSoldOut();
		if (isAvailableHnm) {
			openPopup(
				$.tmpl('hnm-temporary-unavailable', {}),
				{
					onClose: result => {
						if (result === 'ok') {
							this._submit();
						}
					}
				}
			);
		} else {
			this._submit();
		}
	}

	_submit() {
		const $form = this.$form;
		let additionalItems = [];

		if (this._rawProduct) {

			if (this._rawProduct.stock) {
				const $variant = $form.find('input[name=variant]:checked');
				const $size = $form.find('input[name=size]:checked');
				if ($variant.length == 0 || $size.length == 0) {
					return;
				}

				const size = $.trim($size.val());
				let url = this._rawProduct.shopUrl;
                const sizeLink = $size.attr('link');
				if(sizeLink) {
					if(sizeLink.match(/^http.+/g)) {
                        url = sizeLink;
					} else {
						url += sizeLink;
					}
				}

				$form.find('input[name=order_id]').val(url);

				const count = $size.attr('count');
				additionalItems.push('Цвет: ' + $.trim($variant.val()));
				$form.find('[name="hiddenColor"]').val($.trim($variant.val()));
				if (!(this._rawProduct.isOneSize && (size === 'no size'))) {
					additionalItems.push('Размер: ' + size);
					$form.find('[name="hiddenSize"]').val($.trim($size.val()));
				}
				additionalItems.push('Артикул: ' + $.trim($variant.attr('artnum')));
                if ($size.attr('soldout') == 1) {
                    additionalItems.push('Нет в наличии');
                    $form.find('[name=sold_out]').val('1');
                } else if (count > 0) {
					additionalItems.push('Остаток: ' + count);
				}

			} else {
				$form.find('[pattr]').each(function () {
					const val = $(this).find('option:selected').val();
					additionalItems.push($(this).attr('pattr') + ': ' + val);
				});
				if (this._rawProduct.soldOut) {
					additionalItems.push('Нет в наличии');
					$form.find('[name=sold_out]').val('1');
				}
			}
		} else {
			if (!this.isStockRawNoticeVisible() && !this.stockRaw()) {
				this.isStockRawNoticeVisible(true);
				return;
			}
		}

		let additional = additionalItems.join('; ');

		const addcItems = [];
		if(this.stockRaw()) {
            addcItems.push(this.stockRaw());
        }
        if(this.additionalInfo()) {
            addcItems.push(this.additionalInfo());
        }
		const addc = addcItems.join(';\r\n');

		if (additional && addc) {
			additional += ';\r\n' + addc;
		}
		else if (addc) {
			additional = addc;
		}
		$form.find('[name=additional_customer]').val(additional);

		if (!IS_LOGGED_IN) {
			MODAL_LOGIN.show(data => {
				if (data) {
					$form.find('input[name=customer_id]').val(data.id);
					this._submitForm();
				}
			});
		} else {
			this._submitForm();
		}
	}

	_idOrders = [];

	_submitForm() {
        loading.show();
        this.submitDisabled(true);

        if(this.isIndividual()) {
        	this._addToCart();
		} else {
            const amount = Number(this.$form.find('[name=amount]').val());
            this._idOrders = [];
            this._saveOrder(amount);
        }
	}

    _saveOrder(number) {
		$.post(
			siteUrl('save_order'),
			this.$form.serialize(),
			response => {
				if (response && response.success) {
					this._idOrders.push(response.id);

					if (number > 1) {
						this._saveOrder(number - 1);
					} else {
						// last submit
						const image = encodeURIComponent(this.$form.find("input[name=save_image]").val()),
							image_big = encodeURIComponent(this.$form.find("input[name=save_image_big]").val());
						$.ajax('packages/save_img', {
							data: {ids: this._idOrders, img: image, img_big: image_big},
							complete: () => {
								// submit complete
								loading.hide();
								this.submitDisabled(false);
								this.isLoaded(false);
								this._showOrderSuccessMessage(response);
								this._onSuccess.fire();
							}
						});
						if(window.fbq) fbq('track', 'AddToCart');
					}
				} else {
					const error = response && response.error ? response.error : 'Ошибка';
					loading.hide();
					notifier.error(error);
					this.submitDisabled(false);
				}
			},
			'json'
		).fail(() => {
			loading.hide();
			notifier.errorXHR();
			this.submitDisabled(false);
		});
	}

	_addToCart() {
		const dataArr = this.$form.serializeArray();
		const data = {};

		for (let i = 0; i < dataArr.length; i++) {
			const key = dataArr[i].name;
			data[key] = dataArr[i].value;
		}
		data.sum = data.sum.toString().replace(',', '.');
		data.shopInfo = this._shopInfo
			? _.pick(
				this._shopInfo,
				['id', 'name', 'name_for_markup', 'shiping', 'shiping_free', 'min_order', 'free_ship',
					'free_ship_availible']
			)
			: null;

		// Saving cart items
        const result = this._cart.addItem(new CartItem(data, this._cart));

        // Saving complete
        loading.hide();
        this.submitDisabled(false);
        if (result) {
			this.isLoaded(false);
			this._showCartSuccessMessage();
			this._onSuccess.fire();
			if (window.fbq) fbq('track', 'InitiateCheckout');
		} else {
        	notifier.error(`${lang('msg_ir_cart_max_price_exceeded')} ${this.maxPrice()} &euro;`);
		}
	}

	_checkSubmitDisable() {
		const product = this.$form.find('input[name=size]:checked');
		this.submitDisabled(product.length === 0);
	}

	_setOrderName(name) {
		name = asString(name).trim();
		this.orderName(name);
		this.orderNameReadOnly(name !== '');
	}

	_setPrice(price) {
		if (price === undefined) {
			const $size = this.$form.find('input[name=size]:checked');
			price = $size.length > 0 ? $size.attr('price') : '';
		}
		this.priceRaw(price);
		this.priceReadOnly(this.price() !== 0);
		this._updateComission(price);
		this.canAdd(!this.isIndividual() || this._cart.canAdd(price * this.amount()));
	}

	_updateComission(price) {
		const comission = parseFloat(this.$form.find('input[name=comission]').val());
		const minCommission = parseFloat(this.$form.find('input[name=min_commission]').val());

		price = parseFloat(price === undefined ? this.price() : price);
		let com = price*(comission/100);

		if(comission > 0.001) {
			com = Math.max(com, minCommission);
		}

		if (isNaN(com)) {
			com = 0;
		}
		this.$form.find('[name=comission_euro]').text(com.toFixed(2).replace('.', ','));
	}

	_showOrHideImageBlock(type) {
		if (type == 'show') {
			this.$form.find('.parrentImageBlock').show();
			this.$form.find('.upperImageBlock').show();
		} else {
			this.$form.find('.parrentImageBlock').hide();
			this.$form.find('.upperImageBlock').hide();
		}
	}
}

function prepareValidators() {
	$.validator.methods.url = function (value, element) {
		// contributed by Scott Gonzalez: http://projects.scottsplayground.com/iri/
		return this.optional(element) || /^https?:\/\/[\w\d_.-]+\.[\w\d_-]+(?:\/.*|)$/i.test(value);
	};

	$.validator.methods.number = function (value, element) {
		return this.optional(element) || /^[-+]?(?:\d+)(?:[.,]\d*)?$/.test(value);
	};
}

function registerTemplates() {
	$.template('co-variants', require('./templates/variants.html'));
	$.template('co-variant-item', require('./templates/variant-item.html'));
	$.template('co-sizes', require('./templates/sizes.html'));
	$.template('co-size-item', require('./templates/size-item.html'));
	$.template('co-variants-simple', require('./templates/variants-simple.html'));
	$.template('co-reviews-by-group', require('./templates/reviews-by-group.html'));
	$.template('co-reviews-by-product', require('./templates/reviews-by-product.html'));
	$.template('co-reviews-by-shop', require('./templates/reviews-by-shop.html'));
	$.template('co-popup-success', require('./templates/co-popup-success.html'));
	$.template('co-popup-success-low-balance', require('./templates/co-popup-success-low-balance.html'));
    $.template('cart-popup-success', require('./templates/cart-popup-success.html'));
    $.template('hnm-temporary-unavailable', require('./templates/hnm-temporary-unavailable.html'));
}



// WEBPACK FOOTER //
// ./modules/packages/create_order/viewmodel.js